import React from 'react';

import { useTranslation } from 'react-i18next';

import { useChat } from '@whelk/hooks';
import { HISTORY_LIST_TYPE } from '@whelk/store/slices/historyListSlice';
import RenameHistoryModal from '@whelk/components/src/HistoryList/components/RenameHistoryModal';

import HistorySection from '../HistorySection';
import {
  CommandKeyIcon,
  FavoriteMenuIcon,
  HistoryMenuIcon,
  KKeyIcon,
  NewChatStarIcon,
} from './icon';
import './style.scss';

const SidebarHistory = () => {
  const { t } = useTranslation();
  const { addNewChat } = useChat();

  return (
    <div className='flex-1 overflow-y-auto px-4'>
      <div
        className='bg-col_brand00/[0.06] md:hover:bg-col_brand00/[0.12] mb-[6px] hidden h-10 cursor-pointer items-center justify-between rounded-[12px] border-[0.5px] border-[#3DAEFF29] pl-3 pr-4 md:flex'
        onClick={addNewChat}
      >
        <div className='flex items-center justify-start gap-2'>
          <div className='text-col_text00 h-5 w-5'>
            <NewChatStarIcon />
          </div>
          <div className={`new-task-text text-col_text00 whitespace-nowrap text-[15px] font-[500]`}>
            {t('sidebar_new_chat')}
          </div>
        </div>
        <div className={`hidden items-center justify-start gap-[5px] opacity-[0.40] md:flex`}>
          <CommandKeyIcon />
          <KKeyIcon />
        </div>
      </div>
      <HistorySection
        icon={<HistoryMenuIcon />}
        title={t('button_chat_history')}
        listType={HISTORY_LIST_TYPE.ALL}
      />
      <HistorySection
        icon={<FavoriteMenuIcon />}
        title={t('starred_list')}
        listType={HISTORY_LIST_TYPE.FAVORITE}
      />
      <RenameHistoryModal />
    </div>
  );
};

export default SidebarHistory;
